import { Button, ButtonProps } from "@chakra-ui/react";
import { Link, Link_T, parseLinkProps } from "@ui/components/link";

export type ButtonLink_T = ButtonProps & Link_T;

/**
 * A Chakra `Button` wrapped in an anchor tag
 * Relies on `Link` wrapper to supply the link
 * @param props for the `Button` and the `Link`
 */
export const ButtonLink = (props: ButtonLink_T) => {
  const { linkProps, rest } = parseLinkProps(props);
  return (
    <Link _hover={{ textDecoration: "none" }} {...linkProps}>
      <Button
        fontSize={{
          base: "14px",
          md: "16px",
          lg: "17px",
          xl: "18px",
        }}
        py={{
          base: "6",
          lg: "8",
        }}
        px="5"
        _hover={{
          bg: "gray.200",
        }}
        {...rest}
      />
    </Link>
  );
};
